var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "whiskey",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m70.618,88.579l1.353-11.903,4.058-36.522c0-.27-.09-.541-.18-.722-.09-.18-.451-.27-.631-.27H24.807c-.27,0-.541.09-.631.27s-.27.451-.18.722l4.058,36.522,1.262,11.903c.09.451.451.812.902.812h39.498c.451,0,.812-.36.901-.812h0Zm-1.713-.992H31.03l-1.172-10.1h40.129l-1.082,10.1Zm-39.228-11.994l-3.878-34.719h48.246l-3.878,34.719H29.677Z",
        },
      }),
      _c("path", {
        staticStyle: { "stroke-width": "0px" },
        attrs: {
          d: "m67.011,60.895h-34.087c-.541,0-.902.361-.902.902s.361.902.902.902h34.177c.541,0,.902-.361.902-.902s-.451-.902-.992-.902h0Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }